import {Range} from 'rc-slider';
import {createSliderWithTooltip} from 'rc-slider';

export default class RangeWithTooltip extends createSliderWithTooltip(Range) {
}
